// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "NextPrevious-module--bx--text-truncate--end--vDfZN";
export var bxTextTruncateFront = "NextPrevious-module--bx--text-truncate--front--2ZH_S";
export var direction = "NextPrevious-module--direction--lezy2";
export var grid = "NextPrevious-module--grid--3rO-y";
export var isHomepage = "NextPrevious-module--isHomepage--1zmbi";
export var link = "NextPrevious-module--link--2ug_g";
export var linkContainer = "NextPrevious-module--link-container--B94a-";
export var name = "NextPrevious-module--name--k_CST";
export var wrapper = "NextPrevious-module--wrapper--nRh4f";